<main class="dashboard">
    <span (click)="goBack()" class="dashboard__back-arrow"><img src="../../../../assets/img/icons/icon_back.svg" alt="Back Icon" /></span>
    <div class="dashboard-header">
        <section class="sub-header">
            <h1>My Dashboard</h1>
        </section>
    </div>
    
    <section class="main-section">
        <div class="row" style="margin:0;padding:10px;">
        <section class="left-section col-md-12 col-lg-2">
            <div class="profile-wrapper">
                <div class="sqr-image-container dashboardImage" *ngIf="profileImage">
                    <img class="img-fluid d-block rounded-circle mx-auto" id="profile-pic" [src]="profileImage">
                </div>
                <div class="action-wrapper">
                    <a routerLink="/my-dashboard/my-settings">Edit My Profile</a>
                </div>
            </div>
            <div class="tip-box">
                <p>Here you can navigate through all your active requests and browse your bookings.</p>
                <p>When a hotelier sends a personal offer to your request, you can click 'View All Offers' to view it.</p>
            </div>
            <button (click)="goToNewSearch()" class="button__request">
              <a>New Request</a>
            </button>
        </section>
        <section class="right-section col-md-12 col-lg-10">
            <div class="requests" >
                <div class="grid-header">
                    <h2>My Requests</h2>
                    <a routerLink="/my-dashboard/my-requests">(view all)</a>
                </div>
                <div class="grid-container row">
                    <div class="col-md-12 col-lg-6" *ngFor="let request of getRequests();let i = index">
                            <div class="grid-item">
                                <app-single-request 
                                    [selectedRequest]="request" 
                                    [dashboard]="true" 
                                    [requestId]="i+1" 
                                    [extrasVisible]="false"
                                    (removeButtonClicked)="removeRequest($event)"> 
                                </app-single-request>
                            </div>
                    </div>
                </div>
            </div>
            <div class="bookings">
                <div class="grid-header">
                    <h2>My Bookings</h2>
                    <a routerLink="/my-dashboard/my-bookings">(view all)</a>
                </div>
                <div class="grid-container row">
                    <div *ngFor="let booking of getBookings()" class="grid-item col-md-12 col-lg-6">
                        <app-single-booking [bookingInfo]="booking" [limitedButtons]="true"></app-single-booking>
                    </div>
                </div> 
            </div>
        </section>
    </div>
    </section>
</main>
<div id="modal-background"></div>
<div id="modal-content">
    <div class="loader"></div>
</div>​
